var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "outerContainer",
    staticClass: "outer"
  }, [_c('common-title', {
    attrs: {
      "title": "全平台变现",
      "color": "#fff",
      "back-color": "transparent",
      "scale": _vm.scale
    }
  }, [_c('div', {
    staticClass: "platforms grid-container radius-21"
  }, _vm._l(_vm.lists, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "platforms-item flexs column jc-c al-c padding-t-60 padding-b-60",
      on: {
        "mouseenter": function ($event) {
          return _vm.mouseEnter(index);
        },
        "mouseleave": function ($event) {
          return _vm.mouseLeave(index);
        }
      }
    }, [_c('img', {
      staticClass: "flexs w-116 h-120 margin-b-30 o-6",
      class: item.isAnimated ? 'animate__animated animate__shakeY duration animate__infinite highlight o-11' : 'light',
      attrs: {
        "src": _vm.getImagePath(item.img)
      }
    }), _c('span', {
      staticClass: "fs-24 c-303650"
    }, [_vm._v(_vm._s(item.name))])]);
  }), 0)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };